export enum HEADER_LINK_TYPE {
  EXTERNAL = 'external',
  INTERNAL = 'internal',
  LIST = 'list',
}
